/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgHelpCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12zm10.977-4.222a2.21 2.21 0 00-1.447.278 2.25 2.25 0 00-.982 1.193.75.75 0 01-1.415-.498 3.75 3.75 0 011.637-1.988 3.71 3.71 0 012.425-.469 3.817 3.817 0 012.373 1.325c.68.814 1.045 1.956.648 3.122-.483 1.424-1.9 2.501-3.309 2.97a.75.75 0 01-.474-1.422c1.13-.377 2.08-1.195 2.363-2.03.194-.572.039-1.178-.379-1.677a2.317 2.317 0 00-1.44-.804zM11.25 17a.75.75 0 01.75-.75h.01a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75z'
      />
    </svg>
  );
}

export default SvgHelpCircle;
